module.exports = __webpack_public_path__ + "static/img/7.da42207.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/4/zh/7.png
// module id = XGN3
// module chunks = 0